import { render, staticRenderFns } from "./SelectDelivery.vue?vue&type=template&id=e191f82e"
import script from "./SelectDelivery.vue?vue&type=script&lang=js"
export * from "./SelectDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports